import { API, API_GET_ID, API_PATCH, API_POST } from "../../Config";

export const handleDeleteLinks = (id) => {

  const f = new FormData();
    f.append("id", id);
    f.append("status", 0);
    
  
    return API_POST(API.UpdateHomepageLink, f);
  };